import React, { Component, PropTypes } from 'react';
import { autobind } from 'core-decorators';

import Formsy from 'formsy-react';

import { sendApi } from 'services/api';

import { Input, TextArea } from 'AppComponents/Forms/Formsy';
import SubmitButton from 'AppComponents/SubmitButton';
import Alert from 'AppComponents/Alert';

import AlreadyReviewed from './AlreadyReviewed';


class BaseReviewForm extends Component {

  static propTypes = {
    children: PropTypes.node,
    newReviewApiEndpoint: PropTypes.string.isRequired,
    newReviewSuccess: PropTypes.func,
    numReviews: PropTypes.number,
    reviewStatus: PropTypes.shape({
      can_review: PropTypes.bool,
      last_reviewed: PropTypes.string,
    }).isRequired,
    type: PropTypes.string,
  };

  static defaultProps = {
    children: null,
    newReviewSuccess: () => {},
    numReviews: null,
    type: 'object',
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      enableSubmit: false,
      isSubmitting: false,
      serverError: null,
    };
  }

  onValid() {
    this.setState({ enableSubmit: true });
  }

  onInvalid() {
    this.setState({ enableSubmit: false });
  }

  @autobind
  handleValidSubmit(data, resetForm, invalidateForm) {
    this.setState({ isSubmitting: true }, () => {
      sendApi(this.props.newReviewApiEndpoint, 'post', data).then(({ response, error }) => {
        this.setState({ isSubmitting: false });
        if (error) {
          if (typeof error === 'object') {
            this.setState({ serverError: error.detail });
            delete error.detail;
            const errors = {};
            error.forEach((field) => {
              errors[field] = error[field][0];
            });
            invalidateForm(errors);
          } else {
            this.setState({ serverError: 'An unknown error occurred. Please try again.' });
          }
        } else {
          resetForm();
          this.props.newReviewSuccess(response);
        }
      });
    });
  }

  render() {
    const {
      newReviewApiEndpoint,
      newReviewSuccess,
      numReviews,
      reviewStatus,
      type,
      children,
      ...formOpts } = this.props;

    let heading = 'Submit a New Review';
    if (this.props.numReviews === 0) heading = 'Submit the First Review!';

    return (
      <div className='review-form-wrapper'>
        <div className='submit-review card'>

          <h4 className='card-header'>{ heading }</h4>

          <div className='card-block'>

            { !reviewStatus.can_review && reviewStatus.last_reviewed ?
              <AlreadyReviewed reviewStatus={reviewStatus} item={this.props.type} />
            : null }

            <Alert type='danger' display={this.state.serverError && true}>
              <strong>Error: </strong>{ this.state.serverError }
            </Alert>

            <Formsy.Form
              className='form'
              method='post'
              onValid={() => this.setState({ enableSubmit: true })}
              onInvalid={() => this.setState({ enableSubmit: false })}
              onValidSubmit={this.handleValidSubmit}
              noValidate
              {...formOpts}
            >

              <Input
                name='title'
                label='Title'
                maxLength={255}
                disabled={!reviewStatus.can_review}
                required
              />

              { children }

              <TextArea
                name='body'
                label='Body'
                cols={40}
                rows={4}
                disabled={!reviewStatus.can_review}
                required
              />

              <div className='form-footer'>
                <div className='aligned-with-input'>
                  <SubmitButton
                    label='Submit Review'
                    enabled={this.state.enableSubmit}
                    isSubmitting={this.state.isSubmitting}
                  />
                </div>
              </div>

            </Formsy.Form>

          </div>

        </div>
      </div>
    );
  }
}

export default BaseReviewForm;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/BaseReview/ReviewForm/index.jsx